import { FC } from 'react';

import { FirstStepForm } from '../FirstStepForm';
import { SecondStepForm } from '../SecondStepForm';
import { ThirdStepForm } from '../ThirdStepForm';

import { IFormByStep } from './FormByStep.types';

export const FormBySteps: FC<IFormByStep> = ({ step, ...props }) => {
  switch (step) {
    case 1:
      return <FirstStepForm {...props} />;
    case 2:
      return <SecondStepForm {...props} />;
    case 3:
      return <ThirdStepForm {...props} />;
    default:
      return null;
  }
};
